import { render, staticRenderFns } from "./InventorySelectModal.vue?vue&type=template&id=5bca4b42"
import script from "./InventorySelectModal.vue?vue&type=script&lang=ts"
export * from "./InventorySelectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports